import Input from './components/Input';
import ProgressBar from './components/ProgressBar';
import Label from './components/Label';
import LabelGroup from './components/LabelGroup';

export default {
  'ui-kit/common/components/Input': Input,
  'ui-kit/common/components/ProgressBar': ProgressBar,
  'ui-kit/common/components/Label': Label,
  'ui-kit/common/components/LabelGroup': LabelGroup,
};
